// import React, { useState } from "react";
// import { Box, useMediaQuery, Divider, Typography } from "@mui/material";
// import ContactCycle from "./ContactCycle";
// import { isTabWidth, teamProfiles } from "../data/database";
// import { customColour } from "../data/colour";

// // Card Component to represent each team member
// const Card = ({
//   image,
//   name,
//   role,
//   expertise,
//   phone,
//   email,
//   linkedIn,
//   twitter,
//   bio,
//   nameTextSize = "1.5rem",
//   textSize = "0.75rem",
//   subTextSize = "0.75rem",
//   isHovered,
//   isExpanded,
// }) => {
//   const isTab = useMediaQuery(isTabWidth);
//   return (
//     <Box
//       sx={{
//         position: "relative",
//         borderRadius: "0.5rem",
//         overflow: "hidden",
//         cursor: "pointer",
//         transition: "transform 0.3s ease",
//         backgroundColor: isExpanded
//           ? customColour.lightBackground
//           : "transparent",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         "&:hover img": {
//           transform: isExpanded ? "none" : "scale(1.1)", // Scale image up on hover only if not expanded
//           filter: isExpanded ? "none" : "blur(2px)", // Frosty blur effect on hover only if not expanded
//           opacity: isExpanded ? 1 : 0.5, // Darken for better contrast with the text
//         },
//       }}
//     >
//       {/* Display Image or White Background based on expansion state */}
//       {!isExpanded ? (
//         <img
//           src={image}
//           alt={name}
//           style={{
//             width: "100%",
//             // height: "100%",
//             objectFit: "contain",
//             transition:
//               "transform 0.3s ease, filter 0.3s ease, opacity 0.3s ease",
//           }}
//         />
//       ) : (
//         // Expanded state: Blank white background with centered content
//         <Box
//           sx={{
//             width: "100%",
//             aspectRatio: isTab ? "2/3" : "4/3",
//             display: "grid",
//             gridTemplateRows: "1fr 4fr",
//             // padding: "1rem",
//             color: "black",
//             // padding: "0.5rem",
//           }}
//         >
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: isTab ? "1fr 2.5fr" : "1fr 7fr",
//               // backgroundColor: customColour.grey,
//               padding: "0.5rem",
//             }}
//           >
//             <Box
//               sx={{
//                 borderRadius: "0.375rem",
//                 aspectRatio: "1/1",
//                 objectFit: "cover",
//                 overflow: "hidden",
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//                 // height: isTab ? "100%" : "auto",
//                 width: isTab ? "100%" : "auto",
//               }}
//             >
//               <img
//                 src={image}
//                 alt={name}
//                 style={{
//                   height: "100%",
//                   borderRadius: "0.375rem",
//                   objectFit: "cover",
//                   transition:
//                     "transform 0.3s ease, filter 0.3s ease, opacity 0.3s ease",
//                 }}
//               />
//             </Box>
//             <Box sx={{ position: "relative", paddingLeft: "1rem" }}>
//               {/* Overlay Text for Name, Role, and Expertise */}
//               <Box sx={{ position: "absolute", bottom: 0 }}>
//                 <h1
//                   style={{
//                     fontSize: nameTextSize,
//                     fontWeight: "500",
//                     // marginTop: "0.5rem",
//                     marginBottom: "0rem",
//                   }}
//                 >
//                   {name}
//                 </h1>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "space-between",
//                     // alignItems: "center",
//                   }}
//                 >
//                   <Box>
//                     <p
//                       style={{
//                         fontSize: subTextSize,
//                         fontWeight: "600",
//                         margin: 0,
//                       }}
//                     >
//                       {role}
//                     </p>
//                     <p
//                       style={{
//                         fontSize: subTextSize,
//                         fontWeight: "200",
//                         margin: 0,
//                       }}
//                     >
//                       {expertise}
//                     </p>
//                   </Box>
//                   <ContactCycle
//                     phone={phone}
//                     email={email}
//                     linkedIn={linkedIn}
//                     twitter={twitter}
//                     iconWidth={isTab ? "0.5rem" : "1rem"}
//                   />
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//           <Box sx={{ padding: "0.5rem" }}>
//             {bio.split("\n\n").map((paragraph, index) => (
//               <Box
//                 component={Typography}
//                 key={index}
//                 paragraph
//                 variant="body1"
//                 sx={{
//                   mb: 3,
//                   fontSize: textSize,
//                   fontWeight: "100",
//                   textAlign: "justify",
//                   "&:last-child": { mb: 0 }, // Remove margin from last paragraph
//                 }}
//               >
//                 {paragraph}
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       )}

//       {/* Overlay Text when hovering */}
//       {/* {!isExpanded && (
//         <Box
//           className="hover-text"
//           sx={{
//             position: "absolute",
//             bottom: "0.5rem",
//             left: "0.5rem",
//             color: "white",
//             padding: "0.75rem",
//             borderRadius: "0 0 8px 8px",
//             transform: isHovered ? "translateY(0)" : "translateY(100%)",
//             opacity: isHovered ? 1 : 0,
//             transition: "all 0.3s ease",
//           }}
//         >
//           <h1
//             style={{
//               fontSize: isTab ? "0.9rem" : "1rem",
//               fontWeight: "300",
//               // marginBottom: "0.25rem",
//             }}
//           >
//             {name}
//           </h1>
//         </Box>
//       )} */}
//     </Box>
//   );
// };

// // Main TeamProfile Component
// const TeamProfile = ({ data, nameTextSize, subTextSize }) => {
//   const isTab = useMediaQuery(isTabWidth);
//   const [hoveredIndex, setHoveredIndex] = useState(null); // Track hovered card index
//   const [expandedIndex, setExpandedIndex] = useState(null); // Track clicked/expanded card index

//   // Constants for grid properties
//   const columns = isTab ? 3 : 6; // Number of columns in the grid

//   return (
//     <Box
//       sx={{
//         display: "grid",
//         gridTemplateColumns: `repeat(${columns}, 1fr)`,
//         gap: "1rem",
//         gridAutoRows: "1fr", // Set height of each row to match span size
//         overflow: "hidden",
//       }}
//     >
//       {data.map((member, index) => {
//         // Determine if this card should be expanded or hidden
//         const isExpanded = expandedIndex === index;
//         const isHidden = expandedIndex !== null && expandedIndex !== index;

//         // Determine the aspect ratio based on conditions
//         const aspectRatio =
//           isTab && isExpanded
//             ? "2 / 3"
//             : !isTab && isExpanded
//             ? "4 / 3"
//             : "1 / 1";

//         return (
//           <Box
//             key={index}
//             onMouseEnter={() => setHoveredIndex(index)}
//             onMouseLeave={() => setHoveredIndex(null)}
//             onClick={() => setExpandedIndex(isExpanded ? null : index)}
//             sx={{
//               width: "100%",
//               gridColumn: isExpanded ? `span ${columns}` : "span 1", // Expand to the full width of the container when clicked
//               // gridRow: isExpanded ? "span 1" : "span 1", // Set height to 3 spans when expanded
//               aspectRatio: aspectRatio,
//               display: isHidden ? "none" : "block", // Hide other elements when one is expanded
//               transition: "all 0.3s ease",
//               position: "relative",
//               overflow: "hidden",
//               zIndex: isExpanded ? 5 : 1, // Bring the expanded card to the front
//               cursor: "pointer",
//             }}
//           >
//             <Card
//               image={member.image}
//               name={member.name}
//               role={member.role}
//               expertise={member.expertise}
//               bio={member.bio}
//               phone={member.phone}
//               email={member.email}
//               linkedIn={member.linkedIn}
//               twitter={member.twitter}
//               isHovered={hoveredIndex === index}
//               isExpanded={isExpanded}
//               nameTextSize={nameTextSize}
//               subTextSize={subTextSize}
//             />
//           </Box>
//         );
//       })}
//     </Box>
//   );
// };

// export default TeamProfile;

// import { useState } from "react";
// import {
//   Box,
//   Typography,
//   IconButton,
//   Button,
//   useMediaQuery,
// } from "@mui/material";
// import { isTabWidth, teamProfiles } from "../data/database";

// const TeamProfile = () => {
//   const [selectedProfile, setSelectedProfile] = useState(null);

//   const contactIcons = [
//     { label: "phone", image: "../../images/svg/phone.svg" },
//     { label: "email", image: "../../images/svg/message.svg" },
//     { label: "linkedIn", image: "../../images/svg/linkedin.svg" },
//     { label: "twitter", image: "../../images/svg/twitter.svg" },
//   ];

//   const isTab = useMediaQuery(isTabWidth);

//   return (
//     <Box sx={{ maxWidth: 1200, margin: "0 auto" }}>
//       {!selectedProfile ? (
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: 4,
//             justifyContent: "center",
//             p: 4,
//           }}
//         >
//           {teamProfiles.map((profile, index) => (
//             <Box
//               key={index}
//               onClick={() => setSelectedProfile(profile)}
//               sx={{
//                 width: isTab ? 100 : 150,
//                 cursor: "pointer",
//                 position: "relative",
//                 overflow: "hidden",
//                 borderRadius: 2,
//               }}
//             >
//               <Box
//                 sx={{
//                   width: "100%",
//                   pt: "100%", // Maintain 1:1 aspect ratio
//                   position: "relative",
//                   transition: "transform 0.3s ease",
//                   "&:hover img": {
//                     transform: "scale(1.2)",
//                     filter: "blur(4px)",
//                   },
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={profile.image}
//                   alt={`${profile.firstName} ${profile.lastName}`}
//                   sx={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "100%",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     bgcolor: "rgba(0, 0, 0, 0.5)",
//                     opacity: 0,
//                     transition: "opacity 0.3s ease",
//                     "&:hover": {
//                       opacity: 1,
//                     },
//                   }}
//                 >
//                   <Box sx={{ color: "white", fontSize: "1rem" }}>
//                     {profile.firstName}
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       ) : (
//         <Box sx={{ p: 4 }}>
//           <Box sx={{ display: "flex", gap: 4, mb: 4 }}>
//             <Box
//               component="img"
//               src={selectedProfile.image}
//               alt={`${selectedProfile.firstName} ${selectedProfile.lastName}`}
//               sx={{
//                 width: 200,
//                 height: 200,
//                 objectFit: "cover",
//                 borderRadius: 2,
//               }}
//             />
//             <Box sx={{ flex: 1, alignSelf: "center" }}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   fontSize: "1.5rem",
//                 }}
//               >
//                 <Box sx={{ fontWeight: 200 }}>{selectedProfile.firstName} </Box>
//                 <Box sx={{ fontWeight: 500 }}>{selectedProfile.lastName}</Box>
//               </Box>
//               <Box sx={{ mt: 1, fontSize: "1.2rem" }}>
//                 {selectedProfile.role}
//               </Box>
//               <Box
//                 sx={{
//                   fontWeight: 200,
//                   fontStyle: "italic",
//                   mb: 1,
//                   fontSize: "0.8rem",
//                 }}
//               >
//                 {selectedProfile.expertise}
//               </Box>

//               <Box sx={{ display: "flex", gap: 2, mt: 0 }}>
//                 {contactIcons.map(
//                   (icon, index) =>
//                     selectedProfile[icon.label] && (
//                       <IconButton
//                         key={index}
//                         href={
//                           icon.label === "email"
//                             ? `mailto:${selectedProfile[icon.label]}`
//                             : selectedProfile[icon.label]
//                         }
//                         target="_blank"
//                       >
//                         <Box
//                           component="img"
//                           src={icon.image}
//                           alt={icon.label}
//                           sx={{ width: 20, height: 20, color: "white" }}
//                         />
//                       </IconButton>
//                     )
//                 )}
//               </Box>
//             </Box>
//           </Box>

//           <Typography
//             variant="body1"
//             sx={{ borderTop: "1px solid", borderColor: "divider", pt: 3 }}
//           >
//             {selectedProfile.bio}
//           </Typography>

//           <Button
//             variant="contained"
//             onClick={() => setSelectedProfile(null)}
//             sx={{ mt: 3, mx: "auto", display: "block" }}
//           >
//             Close
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default TeamProfile;

import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { isTabWidth, teamProfiles } from "../data/database";

const TeamProfile = () => {
  const [selectedProfile, setSelectedProfile] = useState(null);
  const isTab = useMediaQuery(isTabWidth);
  const isMobile = useMediaQuery("(max-width:600px)");

  const contactIcons = [
    { label: "phone", image: "../../images/svg/phone.svg" },
    { label: "email", image: "../../images/svg/message.svg" },
    { label: "linkedIn", image: "../../images/svg/linkedin.svg" },
    { label: "twitter", image: "../../images/svg/twitter.svg" },
  ];

  return (
    <Box sx={{ maxWidth: 1200, margin: "0 auto", position: "relative" }}>
      {!selectedProfile ? (
        <Grid container spacing={2} sx={{ p: 2 }}>
          {teamProfiles.map((profile, index) => (
            <Grid item xs={4} md={2} key={index}>
              <Box
                onClick={() => setSelectedProfile(profile)}
                sx={{
                  cursor: "pointer",
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: 2,
                  "&:hover .hover-overlay": { opacity: 1 },
                  "&:hover img": {
                    transform: "scale(1.2)",
                    filter: "blur(4px)",
                  },
                }}
              >
                <Box sx={{ pt: "100%", position: "relative" }}>
                  <Box
                    component="img"
                    src={profile.image}
                    alt={`${profile.firstName} ${profile.lastName}`}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "all 0.3s ease",
                    }}
                  />
                  <Box
                    className="hover-overlay"
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "rgba(0, 0, 0, 0.5)",
                      opacity: 0,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <Box sx={{ color: "white", fontSize: "1rem" }}>
                      {profile.firstName}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box sx={{ p: 4 }}>
          <IconButton
            onClick={() => setSelectedProfile(null)}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "white",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              gap: 4,
              mb: 4,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Box
              component="img"
              src={selectedProfile.image}
              alt={`${selectedProfile.firstName} ${selectedProfile.lastName}`}
              sx={{
                width: { xs: "100%", md: 200 },
                height: 200,
                objectFit: "cover",
                borderRadius: 2,
              }}
            />
            <Box
              sx={{
                flex: 1,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <Box sx={{ fontSize: "1.5rem", fontWeight: 200 }}>
                {selectedProfile.firstName}{" "}
                <strong>{selectedProfile.lastName}</strong>
              </Box>
              <Box sx={{ mt: 1, color: "white", fontSize: "1.2rem" }}>
                {selectedProfile.role}
              </Box>
              <Box
                sx={{
                  fontWeight: 200,
                  fontStyle: "italic",
                  mb: 1,
                  fontSize: "0.8rem",
                }}
              >
                {selectedProfile.expertise}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  mt: 2,
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                {contactIcons.map(
                  (icon, index) =>
                    selectedProfile[icon.label] && (
                      <a
                        key={index}
                        href={
                          icon.label === "email"
                            ? `mailto:${selectedProfile[icon.label]}`
                            : selectedProfile[icon.label]
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Box
                          component="img"
                          src={icon.image}
                          alt={icon.label}
                          sx={{
                            width: 24,
                            height: 24,
                            filter: "invert(1) brightness(2)",
                          }}
                        />
                      </a>
                    )
                )}
              </Box>
            </Box>
          </Box>

          <Typography
            variant="body1"
            sx={{
              borderTop: "1px solid",
              borderColor: "divider",
              pt: 3,
              mt: { xs: 4, md: 0 },
              textAlign: "justify",
            }}
          >
            {selectedProfile.bio.split("\n\n").map((paragraph, index) => (
              <span key={index}>
                {paragraph.split("\n").map((line, lineIndex) => (
                  <span key={lineIndex}>
                    {line}
                    <br />
                  </span>
                ))}
                <br />
                <br />
              </span>
            ))}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TeamProfile;
